import {computed, inject} from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { signalStore, withComputed, withMethods, withProps } from '@ngrx/signals';
import {PartnerApi} from "../../../../../core/data/partner/partner.api";

export const PartnersStore = signalStore(
withProps((store, partnerApi = inject(PartnerApi)) => {
   return {
     _partners: rxResource({
       stream: () => partnerApi.getPartners(),
     })
   };
 }),
 withComputed(({ _partners }) => ({
   // Exposed Data Signals
   partners: computed(() => _partners.value() || []),
 })),
 withMethods((store) => ({
   reload: () => {
     if (store._partners.error()) {
       store._partners.reload();
     }
   },
 })),
);
